<template>
  <div class="results">
    <template v-if="pagedResources && pagedResources.length > 0">
      <template v-for="(resource, index) in pagedResources">
        <Resource :key="index" :resource="resource" />
      </template>
    </template>
    <template v-else-if="!loading && pagedResources.length == 0">
      <div class="no-results">
        {{ noResourcesFound }}
      </div>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import content from '@/translations/content'
import Resource from '@/components/Resource'

export default {
  name: 'ResourcesList',
  mixins: [ content ],
  components: { Resource },
  props: {
    filteredResources: Array,
    countPerPage: Number,
    pageNum: Number
  },
  computed: {
    pagedResources() {
      if (this.filteredResources && this.filteredResources.length > 0) {
        return this.filteredResources.slice(this.countPerPage * this.pageNum, this.countPerPage * (this.pageNum + 1))
      } else {
        return []
      }
    },
    ...mapState(['loading'])
  }
}
</script>